import React, { useCallback } from 'react';
import { useHistory  } from 'react-router-dom';
import camelCase from 'lodash/camelCase';
import MenuItem from '@mui/material/MenuItem';
import TextField from '@mui/material/TextField';

export default function GlobalResourceDropDown({ value }) {
  const { push } = useHistory();
  const handleChange = useCallback(event => {
    push(`/account/${camelCase(event.target.value)}`);
  }, [push]);

  return (
    <TextField
      defaultValue={value}
      select
      onChange={handleChange}
    >
      {options.map(option => (
        <MenuItem
          key={option}
          component={MenuItem}
          value={option}
        >
          {option}
        </MenuItem>
      ))}
    </TextField>
  );
}

const options = [
  'Indicators',
  'Impact Models',
  'Cause Categories',
  'Tags',
];
